import image from "../../images/trade-convert.jpg"

export default function TradeConvert() {
  return (
    <>
      <section className="gray">
        <div className="px-5 2xl:px-0 md:grid grid-cols-2 gap-10 items-center py-10 lg:py-20 xl:max-w-6xl xl:mx-auto">
          <article>
            <h2 className="text-3xl lg:text-5xl mb-5">
              Convert Leads Into Paying Customers
            </h2>
            <p>
              Our WebTrader platform is customizable and tailored to your needs.
              Our advanced web-based technology syncs seamlessly with your
              MT4/MT5 so you can trade smarter wherever you are. Brand according
              to your broker's request at no extra cost. With advanced charting
              capabilities, customizable features, and the most powerful
              charting software on the market, our WebTrader allows you to be
              even more profitable. It is lightning fast, customizable, and
              built to be an all-in-one solution that will cover all your needs.
            </p>
          </article>

          <article className="mt-10 md:mt-0">
            <img
              src={image}
              alt="Trade Smarter With the World's No. 1 Trading Platform"
              title="Trade Smarter With the World's No. 1 Trading Platform"
              className="block mx-auto"
            />
          </article>
        </div>
      </section>
    </>
  )
}
